import React, { useState } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import WhoWeServe from "@/components/site/WhoWeServe";
import Services from "@/components/site/Services";
import Estimator from "@/components/site/Estimator";
import Process from "@/components/site/Process";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import useSEO from "@/lib/useSEO";

export default function Home() {
  const [estimatorSnapshot, setEstimatorSnapshot] = useState(null);
  useSEO({
    title: "IncentTax | Cost Segregation & R&D Tax Credit Specialists",
    description:
      "Incent Tax helps property owners, real estate investors, and businesses maximize tax savings through cost segregation studies and R&D tax credit studies. Schedule a free consultation today.",
    canonical: "https://incenttax.com/",
  });

  return (
    <div data-testid="home-page" className="bg-ivory text-forest-950">
      <Navbar />
      <main>
        <Hero />
        <WhoWeServe />
        <Services />
        <Estimator onResult={setEstimatorSnapshot} />
        <Process />
        <Contact estimatorSnapshot={estimatorSnapshot} />
      </main>
      <Footer />
    </div>
  );
}
